import { Button } from '@britishcouncil/react-admin';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath } from 'react-router';
import { ROUTING_PATHS } from 'const';

type Props = {
  isSaving: boolean;
  saved: boolean;
  sessionId: number;
  disabled: boolean;
  onConfirm: () => void;
};

export const Footer = ({ isSaving, saved, sessionId, onConfirm, disabled }: Props) => {
  const { speakingSessionDetails } = ROUTING_PATHS;

  return (
    <Modal.Actions>
      <Link to={generatePath(speakingSessionDetails.absolutePath, { sessionId })}>
        <Button compact type="reset" secondary>
          Cancel
        </Button>
      </Link>

      <Button
        compact
        color="blue"
        onClick={onConfirm}
        disabled={disabled || isSaving || saved}
        loading={isSaving}
      >
        Confirm
      </Button>
    </Modal.Actions>
  );
};
